var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "#17A1E6",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1883.996 -2205)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.266-13.047a.234.234,0,0,0,.234-.234v-.937a.234.234,0,0,0-.234-.234H.234A.234.234,0,0,0,0-14.219v.937a.234.234,0,0,0,.234.234Zm0,6.25a.234.234,0,0,0,.234-.234v-.937a.234.234,0,0,0-.234-.234H.234A.234.234,0,0,0,0-7.969v.937A.234.234,0,0,0,.234-6.8Zm0,6.25A.234.234,0,0,0,17.5-.781v-.937a.234.234,0,0,0-.234-.234H.234A.234.234,0,0,0,0-1.719v.937a.234.234,0,0,0,.234.234Z",
    transform: "translate(1885.246 2222.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 20,
    height: 20,
    transform: "translate(1883.996 2205)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.dcd33e96ad58b13cc48739a837cad2fa.svg";
export { ForwardRef as ReactComponent };